/**
 * 시군구 카드 element id / 펼침 키 헬퍼.
 *
 * 컴포넌트 파일에 두면 react-refresh가 깨지므로 별도 utility 파일로 분리.
 */

/** DongAccordion 펼침 키 — buildAccordionKey 결과 string */
export type AccordionKey = string

/**
 * 시군구 카드 DOM id — 지도 라벨 클릭 시 `getElementById(...)?.scrollIntoView()` 타겟.
 * 키는 백엔드 SiGunGu.name(한글) — 예: 'accordion-수원시'.
 */
export const getSiGunGuAccordionId = (sigunguName: string) => `accordion-${sigunguName}`

/**
 * 펼침 상태 키 — `${시군구이름}__${일반구이름|"all"}`.
 *
 * 일반구 보유 시군구는 일반구별 카드마다 별도 키.
 * 일반구 없는 partial 시군구는 시군구당 카드 1개라 ilbanGuName=null → "all" 사용.
 */
export const buildAccordionKey = (sigunguName: string, ilbanGuName: string | null): AccordionKey =>
  `${sigunguName}__${ilbanGuName ?? 'all'}`
